/**
 * Asynchronously loads the component for FeaturePage
 */

import { loadable } from '@elliemae/pui-app-sdk';

export const Programs = loadable(
  () =>
    import(
      /* webpackChunkName: "datapage1" */ /* webpackPrefetch: true */ './index'
    ),
);
